
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 30 30","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"30","height":"30","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAQAAACROWYpAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLHRSHFUAdAAAC5UlEQVQ4y4WUe2jNYRjHv+ccu1gbM7OmmcVyn1vINVE20v5QRJFbwrTcmj9WZKKVa0pZuU0RoUTLmCF0TIjI3FaOjV3cLyfpnI7Zxx/nt9Pv/Tmb3/vP832e5/s+7+95v+/jQp1+Ls1QnlL0STGaphzF6Zceqlyn1SqJzlYWXj5zkBJeE6CIwaSRw3p83CWDTsn9aaKcJAsdojoSSeAsz4jtmBrHU8psOJM/dI+gWF6wumPyJmqJMTwtTLShDVS6ozZpnApVrCP6bfj9SpTkUbI8kl4p69+KE3jCd25QT5BSI+LnPHUAtOJlBw+c1NkE2ExXhBjCB1ZGIqnAYWaRQTey2EiImyY1nW8st+EFNOG27IXUGrl7eCmHo8rAMfgZa9mVbDNi2TgO/YZ8h6eGRQgxmiB9jEgOgfZuT9I1BdVP85VgdDikGPXUeJ3SMTUZkTnyhneZS4CtDGIot6jGE9l9GB9pBL4QpI0nrIrE+uJnZriPfuZZzmTeUWgdtIogNSyzdNWdFTRQTQKiF7UcDWt7E17bvyymmSR2E2AvvRwdSMJLGbnUc57YMPkOq2wJbppp4CHDo4p2DG38YAMuFCb/dCRW8ZjYDh8p9GhHXRSvRH00+nhFa3RAPRTSc13XI9nnxSi90fd24Fa8pFSDnKgU/dA9PddYXZNPBfJEnkyRztgyKSBInnG0QioidjzLaeAqcQgXu3hre9Nya7bqNNmonKn3ETuo4xqpFK3TAFVosfLlt1duopS6cPesdYMCR5u24yfEMdJMv2hjKF9tmk4nxEAHuYQHTmKY/Ics1vPWCro4zSVHkosaiqJdnGhhOi5O0MxetnCbejIc1J000i06+Rz7EC7mc59WbjPCUFsud2ggJ7pkxFR+kW3BKVzmNz4ucoiT+PjAZ7ZFr9ouz/34bAJNJpe1XOAnj5jiGL5RyB5KCVJOHpn0ZgLFPKOZJcb1dUgOT8oyXtMGtFDBUmt+/mf9BfKdkf9eiQhQAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    